import { useUserOrganization } from '@modules-deprecated/app/organization'

import { OrganizationMarket } from '../types/organizationMarket'

export const useOrganizationMarket = (): { market: OrganizationMarket } => {
  const { organization } = useUserOrganization()
  let market: OrganizationMarket = ''

  switch (organization?.countryId) {
    case 'NL':
      market = 'nl'
      break
    case 'DE':
      market = 'de'
      break
    case 'FR':
      market = 'fr'
      break
    default:
      market = ''
  }

  return { market }
}
